<div #rteEl class="rte" [class.rte--maximized]="maximized">
	<div class="rte__toolbar" *ngIf="editor && !(source_mode && maximized)"
	     [class.rte__toolbar--source]="source_mode">
		<select class="rte__select" [(ngModel)]="heading_value" (change)="setHeading()" [title]="t.paragraphStyle"
		        [disabled]="is_disabled">
			<option value="p">{{ t.paragraph }}</option>
			<option value="1">H1</option>
			<option value="2">H2</option>
			<option value="3">H3</option>
		</select>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [class.active]="active.bold" [title]="t.bold"
		        (mousedown)="$event.preventDefault()" (click)="toggleBold()"><b>B</b></button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [class.active]="active.italic" [title]="t.italic"
		        (mousedown)="$event.preventDefault()" (click)="toggleItalic()"><i>I</i></button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [class.active]="active.blockquote" [title]="t.quote"
		        (mousedown)="$event.preventDefault()" (click)="toggleQuote()">&#8220;&#8221;</button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [class.active]="active.bulletList" [title]="t.bulletedList"
		        (mousedown)="$event.preventDefault()" (click)="toggleBulletList()">&#8226;&nbsp;{{ t.list }}</button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [class.active]="active.orderedList" [title]="t.numberedList"
		        (mousedown)="$event.preventDefault()" (click)="toggleOrderedList()">1.&nbsp;{{ t.list }}</button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [class.active]="active.link" [title]="t.link"
		        (mousedown)="$event.preventDefault()" (click)="toggleLinkPanel($event)">
			<svg class="rte__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
			     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
				<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
				<path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
			</svg>
		</button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" *ngIf="enableImages" [title]="t.image"
		        (mousedown)="$event.preventDefault()" (click)="toggleImagePanel($event)">&#128247;</button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [title]="t.insertTable"
		        (mousedown)="$event.preventDefault()" (click)="toggleTableGrid($event)">&#9638;&nbsp;{{ t.insertTable }}</button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [title]="t.undo"
		        (mousedown)="$event.preventDefault()" (click)="undo()">&#8634;</button>
		<button type="button" class="rte__btn" [disabled]="is_disabled" [title]="t.redo"
		        (mousedown)="$event.preventDefault()" (click)="redo()">&#8635;</button>
		<button type="button" class="rte__btn rte__btn--expand" *ngIf="!maximized" [title]="t.maximize"
		        (mousedown)="$event.preventDefault()" (click)="toggleMaximized()">
			<svg class="rte__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
			     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
				<path d="M15 3h6v6"/>
				<path d="M9 21H3v-6"/>
				<path d="M21 3l-7 7"/>
				<path d="M3 21l7-7"/>
			</svg>
		</button>
	</div>

	<div #contentEl class="rte__content" [class.rte__content--hidden]="source_mode"
	     [style.--rte-min]="minHeight + 'px'" [style.--rte-max]="maxHeight + 'px'"
	     (pointerdown)="onContentPointerDown($event)"></div>

	<textarea *ngIf="source_mode" class="rte__source" [style.min-height.px]="minHeight" [disabled]="is_disabled"
	          [(ngModel)]="source_html" (ngModelChange)="onSourceInput()"></textarea>

	<div class="rte__modeswitch" *ngIf="showSource">
		<button type="button" class="rte__mode" [class.active]="!source_mode"
		        [attr.aria-pressed]="!source_mode" (click)="setSourceMode(false)">{{ t.visual }}</button>
		<button type="button" class="rte__mode" [class.active]="source_mode"
		        [attr.aria-pressed]="source_mode" (click)="setSourceMode(true)">{{ t.source }}</button>
	</div>

	<button type="button" class="rte__ok" *ngIf="maximized"
	        (mousedown)="$event.preventDefault()" (click)="toggleMaximized()">{{ t.ok }}</button>
</div>

<!-- Moved to <body> on init: these are position:fixed, which anchors to the nearest transformed
     ancestor (a dragged modal, a Material dialog) instead of the viewport. -->
<div #popupsEl>
<div class="rte__tablegrid" *ngIf="table_grid_open" [style.top.px]="grid_pos.top" [style.left.px]="grid_pos.left">
	<div class="rte__tablegrid-cells">
		<ng-container *ngFor="let r of grid_range">
			<button type="button" class="rte__tablegrid-cell" *ngFor="let c of grid_range"
			        [class.active]="r < grid_rows && c < grid_cols"
			        [attr.data-row]="r" [attr.data-col]="c"
			        [attr.tabindex]="r === grid_focus_row && c === grid_focus_col ? 0 : -1"
			        [attr.aria-label]="t.insertTable + ' ' + (c + 1) + ' × ' + (r + 1)"
			        (mousedown)="$event.preventDefault()"
			        (mouseover)="hoverGrid(r, c)" (focus)="hoverGrid(r, c)"
			        (keydown)="onGridKeydown($event, r, c)" (click)="pickGrid(r, c)"></button>
		</ng-container>
	</div>
	<div class="rte__tablegrid-label">{{ grid_cols }} × {{ grid_rows }}</div>
</div>

<div class="rte__linkpanel" *ngIf="link_panel_open" [style.top.px]="link_pos.top" [style.left.px]="link_pos.left">
	<input type="text" class="rte__url" placeholder="https://..." [(ngModel)]="link_url" (keydown.enter)="applyLink()">
	<label><input type="checkbox" [(ngModel)]="link_new_tab"> {{ t.openInNewTab }}</label>
	<button type="button" class="rte__btn" [disabled]="is_disabled" (click)="applyLink()">{{ t.apply }}</button>
	<button type="button" class="rte__btn" [disabled]="is_disabled" (click)="removeLink()">{{ t.remove }}</button>
</div>

<div class="rte__imagepanel" *ngIf="image_panel_open" [style.top.px]="image_pos.top" [style.left.px]="image_pos.left">
	<input type="text" class="rte__url" placeholder="https://..." [title]="t.imageUrl"
	       [(ngModel)]="image_url" (keydown.enter)="applyImage()">
	<input type="text" class="rte__alt" [placeholder]="t.altText" [title]="t.altText"
	       [(ngModel)]="image_alt" (keydown.enter)="applyImage()">
	<div class="rte__dim">
		<input type="number" min="0" [placeholder]="t.width" [(ngModel)]="image_width" (keydown.enter)="applyImage()">
		<select [(ngModel)]="image_width_unit">
			<option value="px">px</option>
			<option value="%">%</option>
		</select>
	</div>
	<div class="rte__dim">
		<input type="number" min="0" [placeholder]="t.height" [(ngModel)]="image_height" (keydown.enter)="applyImage()">
		<select [(ngModel)]="image_height_unit">
			<option value="px">px</option>
			<option value="%">%</option>
		</select>
	</div>
	<button type="button" class="rte__btn" [disabled]="is_disabled" (click)="applyImage()">{{ t.insert }}</button>
</div>

<div class="rte__resize" *ngIf="resize_target" [style.top.px]="resize_pos.top" [style.left.px]="resize_pos.left">
	<input *ngIf="resize_target.type === 'image'" type="text" class="rte__resize-alt"
	       [placeholder]="t.altText" [title]="t.altText" [(ngModel)]="resize_alt" (change)="applyResize()">
	<div class="rte__resize-size">
		<input type="number" min="0" [placeholder]="t.width" [(ngModel)]="resize_width" (change)="applyResize()">
		<select [(ngModel)]="resize_width_unit" (change)="applyResize()">
			<option value="px">px</option>
			<option value="%">%</option>
		</select>
		<span class="rte__resize-x">×</span>
		<input type="number" min="0" [placeholder]="t.height" [(ngModel)]="resize_height" (change)="applyResize()">
		<select [(ngModel)]="resize_height_unit" (change)="applyResize()">
			<option value="px">px</option>
			<option value="%">%</option>
		</select>
	</div>
</div>
</div>
